import { Environment, WindowExtension } from './Environment';

export class Config {
    public static get default(): Config {
        const win = window as unknown as WindowExtension;

        return new Config(win.ProductFinderENV || {});
    }

    constructor(private readonly env: Environment) {
    }

    get basePath(): string {
        return `${process.env.PUBLIC_URL}`;
    }

    get isDevelopmentEnv(): boolean {
        return process.env.NODE_ENV === 'development';
    }

    get language(): string {
        return this.env.twoLetterIsoCode || 'de';
    }
}
